const wiehag_edit_settings = [
  {
    'set-editjd': {
      settings: [],
      cherryPick: [
        'woodType',
        'lamellaThickness',
        'lamellaWidth',
        'lamellaLength',
        'lamellaPlannedThickness',
        'lamellaPlannedWidth',
        'numLamellas',
        'zincDoneNumLamellas',
        'producingOnZinc',
        'finishedProducingOnZinc',
        'extraLamella',
        'finishedProducingInsZinc',
        'producingOnISoZinc',
        'insZincDoneNumLamellas',
        'insNumLamellas',
        'insRawNumLamellas',
        'skipIsoDimension',
        'extraLamellaOrder',
        'acknowledgedAtZinc',
        //'stackNum',
        //'direction',
        'grade',
        'quality',
        'noFingerJointingNeeded'
      ]
    }
  },
  {
    'set-editControlOrder': {
      settings: [],
      cherryPick: [
        'orderNumber',
        'status',
        'woodType',
        'sentToPress',
        //'assignedPress',
        'pressId',
        //'direction',
        'allStacksInStorage',
        //'layers',
      ]
    }
  },
  {
    'set-layer-fields': {
      cherryPick: [
      ]
    }
  }
];

export default wiehag_edit_settings;
